/** Enlace público de una trivia: abre su ficha, desde la que se juega o se estudia. */
export function quizShareUrl(quizId: string): string {
  return `${location.origin}/t/${encodeURIComponent(quizId)}`;
}

/** Id de la trivia si la página se abrió desde su enlace (`/t/<id>`). */
export function sharedQuizIdFromPath(): string | null {
  const match = /^\/t\/([^/]+)\/?$/.exec(location.pathname);
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Comparte el enlace de una trivia. En el móvil abre el menú del sistema
 * (WhatsApp, Telegram…), que es lo que la gente espera ahí; en escritorio ese
 * menú es pobre o no existe y se copia al portapapeles.
 *
 * Devuelve 'copied' si quedó en el portapapeles, 'shared' si se usó el menú
 * del sistema, 'failed' si el navegador no dejó copiar, o null si la persona
 * canceló el menú.
 */
export async function shareQuiz(
  quiz: { id: string; title: string },
): Promise<'copied' | 'shared' | 'failed' | null> {
  const url = quizShareUrl(quiz.id);
  const esTactil = matchMedia('(pointer: coarse)').matches;
  if (esTactil && typeof navigator.share === 'function') {
    try {
      await navigator.share({ title: quiz.title, text: `Juega «${quiz.title}» en Open Dahu`, url });
      return 'shared';
    } catch (err) {
      // Cancelar el menú no es un fallo ni motivo para copiar a escondidas.
      if (err instanceof DOMException && err.name === 'AbortError') return null;
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    return 'copied';
  } catch {
    return 'failed';
  }
}
